module.exports = __webpack_public_path__ + "g.no2.aa48afda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/g.no2.jpg
// module id = xqyO
// module chunks = 0